__webpack_require__.p = "//cdn.linkheer.com/o2o/mj-weex-basic/0.0.17/";